import { createRouter, createWebHistory } from 'vue-router';
import SolutionSelector from './SolutionSelector.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.vue-solution-selector', SolutionSelector, {
  jsonProps: ['options', 'raw-solutions', 'raw-categories'],
  beforeMount: (el, props) => {},
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});